"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

import assert from "@brillout/assert";
import load_font from "./load_font";
import _load_font_list from "./load_font_list";
import { set_background } from "./set_background/set_background";
import "./tab-settings.css";
import { track_event, track_error } from "../views/common/tracker";
import { remove_hash } from "../auto_remove_hash";
import { TextInput, BooleanInput, SelectInput, ColorInput, DateInput, Button } from "./PersistantInput";
import { show_toast } from "../views/common/show_toast";
import { run_migrations } from "./run_migrations";
import { store, deserialize, serialize } from "../store";
run_migrations();
export var TabSettings = /*#__PURE__*/function () {
  function TabSettings(_ref) {
    var _this = this;

    var option_spec_list = _ref.option_spec_list,
        preset_spec_list = _ref.preset_spec_list,
        _ref$text_container = _ref.text_container,
        text_container = _ref$text_container === void 0 ? null : _ref$text_container,
        _ref$no_random_preset = _ref.no_random_preset,
        no_random_preset = _ref$no_random_preset === void 0 ? false : _ref$no_random_preset,
        on_any_change = _ref.on_any_change,
        _ref$on_font_change = _ref.on_font_change,
        on_font_change = _ref$on_font_change === void 0 ? null : _ref$on_font_change,
        enable_import_export = _ref.enable_import_export,
        subapp_id = _ref.subapp_id,
        preset_concept_name = _ref.preset_concept_name;

    _classCallCheck(this, TabSettings);

    this.preset_concept_name = void 0;
    this.text_container = void 0;
    this.no_random_preset = void 0;
    this.on_any_change = void 0;
    this.on_font_change = void 0;
    this.enable_import_export = void 0;
    this.subapp_id = void 0;
    this.creator_content = void 0;
    this.options_content = void 0;
    this.options_container = void 0;
    this.save_content = void 0;
    this.save_container = void 0;
    this.share_content = void 0;
    this.share_container = void 0;
    this.preset_list = void 0;
    this.option_list = void 0;
    this.resolve_font_loaded_promise = void 0;
    this.font_loaded_promise = void 0;
    this.button_mod = void 0;
    this.button_del = void 0;
    this.name_option = void 0;
    this.button_url = void 0;
    Object.defineProperty(this, _global_side_effects__timeout, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _previous_link, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _link_el, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _font_list_already_loading, {
      writable: true,
      value: false
    });
    assert(preset_concept_name);
    {
      var hasTextFontInput = !!option_spec_list.find(function (_ref2) {
        var option_type = _ref2.option_type;
        return option_type === "text-font-input";
      });
      var hasTextShadowInput = !!option_spec_list.find(function (_ref3) {
        var option_type = _ref3.option_type;
        return option_type === "text-shadow-input";
      });
      var hasTextColorInput = !!option_spec_list.find(function (_ref4) {
        var option_type = _ref4.option_type;
        return option_type === "text-color-input";
      });
      assert(!text_container && !on_font_change && !hasTextFontInput && !hasTextShadowInput && !hasTextColorInput || text_container && on_font_change && hasTextFontInput && hasTextShadowInput && hasTextColorInput);
    }
    this.preset_concept_name = preset_concept_name;
    this.text_container = text_container;
    this.no_random_preset = no_random_preset;
    this.on_any_change = on_any_change;
    this.on_font_change = on_font_change;
    this.enable_import_export = enable_import_export;
    this.subapp_id = subapp_id;
    this.creator_content = document.getElementById("creator-content");
    this.options_content = document.getElementById("options-content");
    this.options_container = document.getElementById("options-container");
    this.save_content = document.getElementById("save-content");
    this.save_container = document.getElementById("save-container");
    this.share_content = document.getElementById("share-content");
    this.share_container = document.getElementById("share-container");
    this.preset_list = new PresetList({
      preset_spec_list: preset_spec_list,
      tab_settings: this
    });
    this.option_list = instantiate_options({
      tab_settings: this,
      option_spec_list: option_spec_list
    });
    this.resolve_font_loaded_promise;
    this.font_loaded_promise = new Promise(function (r) {
      return _this.resolve_font_loaded_promise = r;
    });
  }

  _createClass(TabSettings, [{
    key: "generate_dom",
    value: function generate_dom() {
      this.option_list.forEach(function (opt) {
        opt.generate_dom();
      });

      if (this.enable_import_export) {
        this.generate_import_export_dom();
      }

      this.global_side_effects({
        is_initial_run: true
      });
    }
  }, {
    key: "generate_import_export_dom",
    value: function generate_import_export_dom() {
      var _this2 = this;

      var input_container = this.creator_content;
      {
        var btn = new Button({
          input_container: input_container,
          text: "Customize",
          className: "action-button",
          on_click: function on_click() {
            _this2.modify_preset();
          },
          id: "modify-preset-button"
        });
        btn.generate_dom();
        this.button_mod = btn;
      }
      {
        var _btn = new Button({
          input_container: input_container,
          text: "Delete",
          className: "action-button",
          on_click: function on_click() {
            _this2.delete_preset();
          },
          id: "delete-preset-button"
        });

        _btn.generate_dom();

        this.button_del = _btn;
      }
      input_container = this.save_content;
      {
        var subapp_id = this.subapp_id;
        assert(subapp_id);
        var name_option = new TextOption({
          input_container: input_container,
          option_id: subapp_id + "_name",
          input_width: "150px",
          option_description: this.preset_concept_name + " name",
          option_default: "",
          tab_settings: this,
          id: "preset-name-input"
        });
        name_option.generate_dom();
        this.name_option = name_option;
      }
      {
        var _btn2 = new Button({
          input_container: input_container,
          text: "Save",
          on_click: function on_click() {
            _this2.save_created_preset();
          },
          id: "save-preset-button"
        });

        _btn2.generate_dom();

        this.button_url = _btn2;
      }
    }
  }, {
    key: "save_created_preset",
    value: function save_created_preset() {
      var preset_selected = this.preset_selected;
      assert(preset_selected.is_creator_preset, preset_selected);
      var preset_name = this.name_option.input_value;

      if (!preset_name) {
        alert("You need to provide a name for your " + this.preset_concept_name + " in order to save it.");
        return;
      }

      var preset_id = NameIdConverter.from_name_to_id(preset_name);

      if (this.preset_list.get_preset_by_name(preset_id, {
        can_be_null: true
      })) {
        var error_msg = "Change the name of your " + this.preset_concept_name + "; " + "you already have a " + this.preset_concept_name + ' saved with ID "' + preset_id + '". (IDs are genrated from name; change name to change ID.)';
        alert(error_msg);
        return;
      }

      var preset_values = {};
      this.option_list.filter(function (option) {
        return option.is_creator_option;
      }).forEach(function (option) {
        var preset_val = option.input_value;
        assert([false, ""].includes(preset_val) || preset_val, option.option_id, preset_val === undefined, {
          preset_val: preset_val
        });
        preset_values[option.option_id] = preset_val;
      });
      var new_preset = new SavedPreset({
        preset_id: preset_id,
        preset_values: preset_values,
        tab_settings: this
      });
      this.preset_list.save_preset(new_preset);
      this.select_preset(new_preset);
      this.reset_creator();
    }
  }, {
    key: "reset_creator",
    value: function reset_creator() {
      // Erase all custom option values
      this.option_list.forEach(function (option) {
        option.reset();
      });
    }
  }, {
    key: "copy_to_creator",
    value: function copy_to_creator() {
      var _this3 = this;

      var preset = this.active_preset;
      assert(preset.is_real_preset);
      var preset_values = preset.preset_values;

      var _loop = function _loop(opt_id) {
        var opt_val = preset_values[opt_id];
        assert(!["preset_name", "preset_id", "id", "name"].includes(opt_val));

        _this3.find_option(function (option) {
          return option.option_id === opt_id;
        }).set_input_value(opt_val);
      };

      for (var opt_id in preset_values) {
        _loop(opt_id);
      }

      this.select_preset_creator();
    }
  }, {
    key: "modify_preset",
    value: function modify_preset() {
      var preset = this.active_preset;
      assert(preset.is_real_preset, preset);
      var new_preset_id = this.preset_list.generate_unique_preset_id_copy(preset);
      this.copy_to_creator();
      this.name_option.set_input_value(NameIdConverter.from_id_to_name(new_preset_id));
    }
  }, {
    key: "delete_preset",
    value: function delete_preset() {
      var preset = this.active_preset;
      assert(preset.is_saved_preset, preset);
      this.copy_to_creator();
      this.name_option.set_input_value(preset.preset_name);
      this.preset_list.remove_preset(preset);
    }
  }, {
    key: "global_side_effects",
    value: function global_side_effects() {
      var _this4 = this;

      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref5$is_initial_run = _ref5.is_initial_run,
          is_initial_run = _ref5$is_initial_run === void 0 ? false : _ref5$is_initial_run;

      if (is_initial_run) {
        this.run_side_effects(true);
        return;
      }

      if (_classPrivateFieldLooseBase(this, _global_side_effects__timeout)[_global_side_effects__timeout]) {
        return;
      }

      _classPrivateFieldLooseBase(this, _global_side_effects__timeout)[_global_side_effects__timeout] = requestAnimationFrame(function () {
        _this4.run_side_effects();

        _classPrivateFieldLooseBase(_this4, _global_side_effects__timeout)[_global_side_effects__timeout] = null;
      });
    }
  }, {
    key: "run_side_effects",
    value: function run_side_effects() {
      var _this5 = this;

      var is_initial_run = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.update_background();

      if (this.text_container) {
        this.update_font();
        this.load_font_list();
      }

      this.update_option_visibility();
      this.update_button_visibility();
      this.on_any_change({
        is_initial_run: is_initial_run
      });
      this.update_share_link();
      this.update_save_block();

      if (is_initial_run) {
        this.load_preset_from_url();
        window.addEventListener("hashchange", function () {
          return _this5.load_preset_from_url();
        }, {
          passive: true
        });
        this.track_user_presets();
        this.set_options_container_visibility();
      }
    }
  }, {
    key: "set_options_container_visibility",
    value: function set_options_container_visibility() {
      var to_hide = this.option_list.every(function (opt) {
        assert(opt.is_creator_option.constructor === Boolean);
        return opt.is_creator_option || opt.is_preset_selector;
      });

      if (to_hide) {
        this.options_container.style.display = "none";
      }
    }
  }, {
    key: "track_user_presets",
    value: function track_user_presets() {
      track_event({
        name: "preset_used",
        value: this.preset_selected.preset_id + " " + this.preset_concept_name.toLowerCase()
      });
    }
  }, {
    key: "update_share_link",
    value: function update_share_link() {
      var preset_selected = this.preset_selected;

      if (!preset_selected.is_saved_preset) {
        this.share_container.classList.add("no-share-link");
        return;
      } else {
        this.share_container.classList.remove("no-share-link");
      }

      var current_link = preset_selected.share_link;

      if (_classPrivateFieldLooseBase(this, _previous_link)[_previous_link] === current_link) {
        return;
      } else {
        _classPrivateFieldLooseBase(this, _previous_link)[_previous_link] = current_link;
      }

      if (!_classPrivateFieldLooseBase(this, _link_el)[_link_el]) {
        _classPrivateFieldLooseBase(this, _link_el)[_link_el] = document.createElement("a");
        _classPrivateFieldLooseBase(this, _link_el)[_link_el].id = "share-link-tag"; // this.#link_el.setAttribute('target', '_blank');

        this.share_content.appendChild(_classPrivateFieldLooseBase(this, _link_el)[_link_el]);
      }

      _classPrivateFieldLooseBase(this, _link_el)[_link_el].setAttribute("href", current_link);

      _classPrivateFieldLooseBase(this, _link_el)[_link_el].textContent = current_link;
    }
  }, {
    key: "update_save_block",
    value: function update_save_block() {
      this.save_container.style.display = this.preset_selected.is_creator_preset ? "" : "none";
    }
  }, {
    key: "load_preset_from_url",
    value: function load_preset_from_url() {
      var preset_url = window.location.href;
      var preset_data = LinkSerializer.from_url();

      if (preset_data === null) {
        return;
      }

      var preset_id = preset_data.preset_id;
      assert(preset_id);
      var preset_conflict = this.preset_list.get_preset_by_name(preset_id, {
        can_be_null: true
      });

      if (preset_conflict) {
        this.select_preset(preset_conflict);
        show_toast(this.preset_concept_name + ' "' + preset_conflict.preset_name + '" already saved.');
        remove_hash();
        return;
      }

      var subapp_id = preset_data.subapp_id;
      assert(subapp_id);
      /* TN2
      const wrong_url_format =
      if( wrong_url_format ){
        alert("URL is incorrect, maybe you inadvertently modified the URL?");
      }
      */

      var wrong_app = subapp_id !== this.subapp_id;

      if (wrong_app) {
        alert("Wrong app: the URL hash should be loaded in a different app.");
        return;
      }

      var preset_values = preset_data.preset_values;
      assert(preset_values);
      var new_preset = new SavedPreset({
        preset_id: preset_id,
        preset_values: preset_values,
        tab_settings: this
      });
      this.preset_list.save_preset(new_preset);
      this.select_preset(new_preset);
      show_toast(this.preset_concept_name + ' "' + new_preset.preset_name + '" successfully saved.');
      remove_hash();
      track_event({
        name: "preset_imported",
        value: this.preset_concept_name + " " + new_preset.preset_name,
        data: {
          preset_url: preset_url
        }
      });
    }
  }, {
    key: "update_background",
    value: function update_background() {
      var image = this.current_backgroud_image;
      var color = this.current_backgroud_color; // set_background(color, image, "#fv_right-side");

      set_background(color, image, "body");
    }
  }, {
    key: "update_font",
    value: function () {
      var _update_font = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this6 = this;

        var text_container, get_font_name;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                text_container = this.text_container;

                get_font_name = function get_font_name() {
                  return _this6.current_font_name;
                };

                _context.next = 4;
                return load_text_font({
                  text_container: text_container,
                  get_font_name: get_font_name
                });

              case 4:
                this.on_font_change();
                this.resolve_font_loaded_promise();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function update_font() {
        return _update_font.apply(this, arguments);
      }

      return update_font;
    }()
  }, {
    key: "update_option_visibility",
    value: function update_option_visibility() {
      var _this7 = this;

      // Visibility of options
      var get_input_val = function get_input_val(dep_option_id) {
        return _this7.find_option(function (option) {
          return option.option_id === dep_option_id;
        }).input_value;
      };

      this.option_list.forEach(function (opt) {
        var to_hide = opt.option_dependency && !get_input_val(opt.option_dependency) || opt.is_creator_option && !_this7.preset_selected.is_creator_preset;

        if (to_hide) {
          opt.hide();
        } else {
          opt.show();
        }
      });
    }
  }, {
    key: "update_button_visibility",
    value: function update_button_visibility() {
      if (!this.enable_import_export) {
        return;
      }

      if (this.preset_selected.is_saved_preset) {
        this.button_del.show();
      } else {
        this.button_del.hide();
      }

      if (this.preset_selected.is_creator_preset) {
        this.button_mod.hide();
        this.button_url.show();
        this.name_option.show(); // this.button_del.hide();
      } else {
        this.button_url.hide();
        this.name_option.hide(); // this.button_del.hide();

        if (!this.preset_selected.is_randomizer_preset) {
          this.button_mod.show();
        } else {
          this.button_mod.hide();
        }
      }
    }
  }, {
    key: "load_font_list",
    value: function () {
      var _load_font_list2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.preset_selected.is_creator_preset) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (!_classPrivateFieldLooseBase(this, _font_list_already_loading)[_font_list_already_loading]) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _classPrivateFieldLooseBase(this, _font_list_already_loading)[_font_list_already_loading] = true;
                _context2.t0 = this.font_option;
                _context2.t1 = [SelectInput.get_divider()];
                _context2.t2 = _toConsumableArray;
                _context2.next = 10;
                return _load_font_list();

              case 10:
                _context2.t3 = _context2.sent;
                _context2.t4 = (0, _context2.t2)(_context2.t3);
                _context2.t5 = _context2.t1.concat.call(_context2.t1, _context2.t4);

                _context2.t0.add_fonts.call(_context2.t0, _context2.t5);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function load_font_list() {
        return _load_font_list2.apply(this, arguments);
      }

      return load_font_list;
    }()
  }, {
    key: "find_option",
    value: function find_option(match) {
      var option = this.option_list.find(match);
      assert(option);
      return option;
    }
  }, {
    key: "select_preset_creator",
    value: function select_preset_creator() {
      this.active_preset = this.preset_list.creator_preset;
    }
  }, {
    key: "select_preset",
    value: function select_preset(preset) {
      this.active_preset = preset;
    }
  }, {
    key: "get_option_value",
    value: function get_option_value(option_id) {
      return this.find_option(function (option) {
        return option.option_id === option_id;
      }).active_value;
    }
  }, {
    key: "background_image_option",
    get: function get() {
      return this.find_option(function (option) {
        return option.is_background_image_option;
      });
    }
  }, {
    key: "current_backgroud_image",
    get: function get() {
      return this.background_image_option.active_value;
    }
  }, {
    key: "background_color_option",
    get: function get() {
      return this.find_option(function (option) {
        return option.is_background_color_option;
      });
    }
  }, {
    key: "current_backgroud_color",
    get: function get() {
      return this.background_color_option.active_value;
    }
  }, {
    key: "font_option",
    get: function get() {
      return this.find_option(function (option) {
        return option.is_font_option;
      });
    }
  }, {
    key: "current_font_name",
    get: function get() {
      return this.font_option.active_value;
    }
  }, {
    key: "active_preset",
    get: function get() {
      var active_preset;
      var preset_selected = this.preset_selected;

      if (preset_selected.is_randomizer_preset) {
        active_preset = preset_selected.random_preset;
      } else {
        active_preset = preset_selected;
      }

      assert(!active_preset.is_randomizer_preset, {
        active_preset: active_preset
      });
      assert(active_preset.preset_id, {
        active_preset: active_preset
      });
      return active_preset;
    },
    set: function set(preset_thing) {
      var preset_id;

      if (preset_thing.constructor === String) {
        preset_id = preset_thing;
      }

      if (preset_thing instanceof Preset || preset_thing instanceof FakePreset) {
        preset_id = preset_thing.preset_id;
      }

      assert(preset_id, {
        preset_thing: preset_thing,
        preset_id: preset_id
      });
      this.preset_option.set_input_value(preset_id);
    }
  }, {
    key: "preset_selected",
    get: function get() {
      var preset_id = this.preset_option.input_value;
      var preset = this.preset_list.get_preset_by_name(preset_id, {
        can_be_null: true
      });

      if (preset) {
        return preset;
      }

      var default_preset_id = this.preset_option.option_default;
      assert(default_preset_id, {
        default_preset_id: default_preset_id
      });
      var default_preset = this.preset_list.get_preset_by_name(default_preset_id);
      return default_preset;
    }
  }, {
    key: "preset_option",
    get: function get() {
      return this.find_option(function (option) {
        return option.is_preset_selector;
      });
    }
  }]);

  return TabSettings;
}();

var _global_side_effects__timeout = _classPrivateFieldLooseKey("global_side_effects__timeout");

var _previous_link = _classPrivateFieldLooseKey("previous_link");

var _link_el = _classPrivateFieldLooseKey("link_el");

var _font_list_already_loading = _classPrivateFieldLooseKey("font_list_already_loading");

var Option = /*#__PURE__*/function () {
  function Option(_ref6) {
    var _this8 = this;

    var option_id = _ref6.option_id,
        option_description = _ref6.option_description,
        option_default = _ref6.option_default,
        input_width = _ref6.input_width,
        tab_settings = _ref6.tab_settings,
        input_container = _ref6.input_container,
        _ref6$is_creator_opti = _ref6.is_creator_option,
        is_creator_option = _ref6$is_creator_opti === void 0 ? false : _ref6$is_creator_opti,
        props = _objectWithoutProperties(_ref6, ["option_id", "option_description", "option_default", "input_width", "tab_settings", "input_container", "is_creator_option"]);

    _classCallCheck(this, Option);

    this.tab_settings = void 0;
    this.option_id = void 0;
    this.option_description = void 0;
    this.input_args = void 0;
    this.is_creator_option = void 0;
    this.option_default = void 0;
    this.user_input = void 0;
    assert(option_id);
    assert(tab_settings);
    Object.assign(this, _objectSpread({
      option_id: option_id,
      tab_settings: tab_settings
    }, props));
    this.is_creator_option = is_creator_option;
    this.option_default = option_default;
    input_container = input_container || (is_creator_option ? this.tab_settings.creator_content : this.tab_settings.options_content);
    assert(input_container, {
      option_id: option_id
    });
    this.input_args = {
      input_id: option_id,
      input_description: option_description,
      on_input_change: function on_input_change() {
        _this8.tab_settings.global_side_effects();
      },
      input_default: option_default,
      input_container: input_container,
      input_width: input_width
    };
  }

  _createClass(Option, [{
    key: "generate_dom",
    value: function generate_dom() {
      if (this.before_dom) {
        this.before_dom();
      }

      assert(this.user_input);
      this.user_input.init();
    }
  }, {
    key: "set_input_value",
    value: function set_input_value(val) {
      this.user_input.input_set(val);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.user_input.hide();
    }
  }, {
    key: "show",
    value: function show() {
      this.user_input.show();
    }
  }, {
    key: "reset",
    value: function reset() {// TODO
    }
  }, {
    key: "input_value",
    get: function get() {
      return this.user_input.input_get();
    }
  }, {
    key: "preset_value",
    get: function get() {
      var preset_val = this.tab_settings.active_preset.get_preset_value(this);
      return preset_val;
    }
  }, {
    key: "active_value",
    get: function get() {
      if (this.tab_settings.preset_selected.is_creator_preset) {
        return this.input_value;
      }

      var preset_value = this.preset_value;

      if (this.is_creator_option) {
        return preset_value;
      }

      if (preset_value !== null) {
        return preset_value;
      }

      return this.input_value;
    }
  }]);

  return Option;
}();

var DateOption = /*#__PURE__*/function (_Option) {
  _inherits(DateOption, _Option);

  function DateOption(args) {
    var _this9;

    _classCallCheck(this, DateOption);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(DateOption).call(this, args));
    _this9.user_input = new DateInput(_this9.input_args);
    return _this9;
  }

  return DateOption;
}(Option);

var BooleanOption = /*#__PURE__*/function (_Option2) {
  _inherits(BooleanOption, _Option2);

  function BooleanOption(args) {
    var _this10;

    _classCallCheck(this, BooleanOption);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(BooleanOption).call(this, args));
    _this10.user_input = new BooleanInput(_this10.input_args);
    return _this10;
  }

  return BooleanOption;
}(Option);

var SelectOption = /*#__PURE__*/function (_Option3) {
  _inherits(SelectOption, _Option3);

  function SelectOption(args, input_options) {
    var _this11;

    _classCallCheck(this, SelectOption);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(SelectOption).call(this, args));
    _this11.user_input = void 0;
    _this11.user_input = new SelectInput(_objectSpread({
      input_options: input_options
    }, _this11.input_args));
    return _this11;
  }

  _createClass(SelectOption, [{
    key: "add_options",
    value: function add_options(args) {
      this.user_input.add_options(args);
    }
  }]);

  return SelectOption;
}(Option);

var ChoiceOption = /*#__PURE__*/function (_SelectOption) {
  _inherits(ChoiceOption, _SelectOption);

  function ChoiceOption(_ref7) {
    var option_choices = _ref7.option_choices,
        args = _objectWithoutProperties(_ref7, ["option_choices"]);

    _classCallCheck(this, ChoiceOption);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChoiceOption).call(this, _objectSpread({
      input_width: "100px"
    }, args), option_choices));
  }

  return ChoiceOption;
}(SelectOption);

var TextOption = /*#__PURE__*/function (_Option4) {
  _inherits(TextOption, _Option4);

  function TextOption(args) {
    var _this12;

    _classCallCheck(this, TextOption);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(TextOption).call(this, args));
    _this12.input_args.input_placeholder = args.option_placeholder;
    _this12.user_input = new TextInput(_this12.input_args);
    return _this12;
  }

  return TextOption;
}(Option);
/*
class TextOption extends Option {
  constructor({option_placeholder, ...args}) {
    super(args);
    this.input_args.input_placeholder = option_placeholder;
    this.user_input = new TextInput(this.input_args);
  }
}
*/


var ColorOption = /*#__PURE__*/function (_Option5) {
  _inherits(ColorOption, _Option5);

  function ColorOption(args) {
    var _this13;

    _classCallCheck(this, ColorOption);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(ColorOption).call(this, _objectSpread({
      input_width: "35px"
    }, args)));
    _this13.user_input = new ColorInput(_this13.input_args);
    return _this13;
  }

  return ColorOption;
}(Option);

var TextColorOption = /*#__PURE__*/function (_ColorOption) {
  _inherits(TextColorOption, _ColorOption);

  function TextColorOption() {
    _classCallCheck(this, TextColorOption);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextColorOption).apply(this, arguments));
  }

  return TextColorOption;
}(ColorOption);

var TextShadowOption = /*#__PURE__*/function (_TextOption) {
  _inherits(TextShadowOption, _TextOption);

  function TextShadowOption() {
    _classCallCheck(this, TextShadowOption);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextShadowOption).apply(this, arguments));
  }

  return TextShadowOption;
}(TextOption);

var PresetOption = /*#__PURE__*/function (_SelectOption2) {
  _inherits(PresetOption, _SelectOption2);

  function PresetOption(_ref8) {
    var _this14;

    var input_options = _ref8.input_options,
        args = _objectWithoutProperties(_ref8, ["input_options"]);

    _classCallCheck(this, PresetOption);

    _this14 = _possibleConstructorReturn(this, _getPrototypeOf(PresetOption).call(this, _objectSpread({
      input_width: "120px",
      input_container: args.tab_settings.creator_content
    }, args), input_options));
    _this14.is_preset_selector = true;
    return _this14;
  }

  _createClass(PresetOption, [{
    key: "before_dom",
    value: function before_dom() {
      this.user_input.input_options = this.get_input_options();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.before_dom();
      this.user_input.refresh();
    }
  }, {
    key: "get_input_options",
    value: function get_input_options() {
      var _this$tab_settings$pr = this.tab_settings.preset_list.presets_ordered,
          special_ones = _this$tab_settings$pr.special_ones,
          saved_ones = _this$tab_settings$pr.saved_ones,
          native_ones = _this$tab_settings$pr.native_ones;
      {
        var map = function map(_ref9) {
          var preset_id = _ref9.preset_id,
              preset_name = _ref9.preset_name;
          assert(preset_id);
          assert(preset_name);
          return {
            val: preset_id,
            val_pretty: preset_name
          };
        };

        special_ones = special_ones.map(map);
        saved_ones = saved_ones.map(map);
        native_ones = native_ones.map(map);
      }
      return saved_ones.length > 0 ? [].concat(_toConsumableArray(special_ones), [SelectInput.get_divider("Saved")], _toConsumableArray(saved_ones), [SelectInput.get_divider("Native")], _toConsumableArray(native_ones)) : [].concat(_toConsumableArray(special_ones), [SelectInput.get_divider()], _toConsumableArray(native_ones));
    }
  }]);

  return PresetOption;
}(SelectOption);

var BackgroundImageOption = /*#__PURE__*/function (_TextOption2) {
  _inherits(BackgroundImageOption, _TextOption2);

  function BackgroundImageOption() {
    var _getPrototypeOf2;

    var _this15;

    _classCallCheck(this, BackgroundImageOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this15 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BackgroundImageOption)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this15.is_background_image_option = true;
    return _this15;
  }

  return BackgroundImageOption;
}(TextOption);

var BackgroundColorOption = /*#__PURE__*/function (_ColorOption2) {
  _inherits(BackgroundColorOption, _ColorOption2);

  function BackgroundColorOption() {
    var _getPrototypeOf3;

    var _this16;

    _classCallCheck(this, BackgroundColorOption);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this16 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(BackgroundColorOption)).call.apply(_getPrototypeOf3, [this].concat(args)));
    _this16.is_background_color_option = true;
    return _this16;
  }

  return BackgroundColorOption;
}(ColorOption);

var FontOption = /*#__PURE__*/function (_SelectOption3) {
  _inherits(FontOption, _SelectOption3);

  function FontOption(_ref10) {
    var _this17;

    var input_optoins = _ref10.input_optoins,
        args = _objectWithoutProperties(_ref10, ["input_optoins"]);

    _classCallCheck(this, FontOption);

    _this17 = _possibleConstructorReturn(this, _getPrototypeOf(FontOption).call(this, _objectSpread({
      input_width: "110px"
    }, args), input_optoins));
    _this17.is_font_option = true;
    return _this17;
  }

  _createClass(FontOption, [{
    key: "before_dom",
    value: function before_dom() {
      this.user_input.input_options = this.tab_settings.preset_list.get_all_preset_fonts();
    }
  }, {
    key: "add_fonts",
    value: function add_fonts(args) {
      this.add_options(args);
    }
  }, {
    key: "input_value",
    get: function get() {
      var val = _get(_getPrototypeOf(FontOption.prototype), "input_value", this);

      assert(val, "empty_font_value", val === undefined, val === "", {
        val: val
      });
      return val;
    }
  }]);

  return FontOption;
}(SelectOption);

function load_text_font(_x) {
  return _load_text_font.apply(this, arguments);
}

function _load_text_font() {
  _load_text_font = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref21) {
    var text_container, get_font_name, font_name;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            text_container = _ref21.text_container, get_font_name = _ref21.get_font_name;
            font_name = get_font_name();
            _context3.next = 4;
            return load_font(font_name);

          case 4:
            if (!(font_name !== get_font_name())) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return");

          case 6:
            if (!(font_name === text_container.style.fontFamily)) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return");

          case 8:
            text_container.style.fontFamily = font_name;

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _load_text_font.apply(this, arguments);
}

function instantiate_options(_ref11) {
  var tab_settings = _ref11.tab_settings,
      option_spec_list = _ref11.option_spec_list;
  return option_spec_list.map(function (_ref12) {
    var option_type = _ref12.option_type,
        option_spec = _objectWithoutProperties(_ref12, ["option_type"]);

    assert(option_spec.option_id, option_spec);

    var args = _objectSpread({}, option_spec, {
      tab_settings: tab_settings
    });

    if (option_type === "text-font-input") {
      return new FontOption(args);
    }

    if (option_type === "preset-input") {
      return new PresetOption(args);
    }

    if (option_type === "text-color-input") {
      return new TextColorOption(args);
    }

    if (option_type === "color-input") {
      return new ColorOption(args);
    }

    if (option_type === "text-shadow-input") {
      return new TextShadowOption(args);
    }

    if (option_type === "text-input") {
      return new TextOption(args);
    }

    if (option_type === "background-image-input") {
      return new BackgroundImageOption(args);
    }

    if (option_type === "background-color-input") {
      return new BackgroundColorOption(args);
    }

    if (option_type === "boolean-input") {
      return new BooleanOption(args);
    }

    if (option_type === "date-input") {
      return new DateOption(args);
    }

    if (option_type === "choice-input") {
      return new ChoiceOption(args);
    }

    assert(false, {
      option_type: option_type
    });
  });
}

var PresetList = /*#__PURE__*/function () {
  function PresetList(_ref13) {
    var preset_spec_list = _ref13.preset_spec_list,
        tab_settings = _ref13.tab_settings;

    _classCallCheck(this, PresetList);

    Object.defineProperty(this, _preset_savior, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _native_presets, {
      writable: true,
      value: null
    });
    this.tab_settings = void 0;
    this.randomizer_preset = void 0;
    this.creator_preset = void 0;
    this.tab_settings = tab_settings;
    _classPrivateFieldLooseBase(this, _preset_savior)[_preset_savior] = new PresetSavior({
      subapp_id: tab_settings.subapp_id
    });

    if (!this.tab_settings.no_random_preset) {
      this.randomizer_preset = new RandomizerPreset({
        preset_list: this
      });
    }

    this.creator_preset = new CreatorPreset();
    _classPrivateFieldLooseBase(this, _native_presets)[_native_presets] = Object.entries(preset_spec_list).map(function (_ref14) {
      var _ref15 = _slicedToArray(_ref14, 2),
          preset_id = _ref15[0],
          preset_values = _ref15[1];

      return new NativePreset({
        preset_id: preset_id,
        preset_values: preset_values,
        tab_settings: tab_settings
      });
    });
  }

  _createClass(PresetList, [{
    key: "save_preset",
    value: function save_preset(preset) {
      _classPrivateFieldLooseBase(this, _preset_savior)[_preset_savior].save_preset(preset);

      this.refresh_user_input();
    }
  }, {
    key: "remove_preset",
    value: function remove_preset(preset) {
      _classPrivateFieldLooseBase(this, _preset_savior)[_preset_savior].remove_preset(preset);

      this.refresh_user_input();
    }
  }, {
    key: "refresh_user_input",
    value: function refresh_user_input() {
      this.tab_settings.preset_option.refresh();
    }
  }, {
    key: "_get_saved_presets",
    value: function _get_saved_presets() {
      var tab_settings = this.tab_settings;
      return _classPrivateFieldLooseBase(this, _preset_savior)[_preset_savior].get_saved_presets().map(function (_ref16) {
        var preset_id = _ref16.preset_id,
            preset_values = _ref16.preset_values;
        return new SavedPreset({
          preset_id: preset_id,
          preset_values: preset_values,
          tab_settings: tab_settings
        });
      });
    }
  }, {
    key: "get_preset_by_name",
    value: function get_preset_by_name(preset_id) {
      var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref17$can_be_null = _ref17.can_be_null,
          can_be_null = _ref17$can_be_null === void 0 ? false : _ref17$can_be_null;

      assert(preset_id);

      var presets = this._get_all_presets();

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = presets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var preset = _step.value;

          if (preset.preset_id === preset_id) {
            return preset;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      assert(can_be_null, "Could not find preset", {
        preset_id: preset_id
      });
    }
  }, {
    key: "get_all_preset_fonts",
    value: function get_all_preset_fonts() {
      var _this$presets_ordered = this.presets_ordered,
          saved_ones = _this$presets_ordered.saved_ones,
          native_ones = _this$presets_ordered.native_ones;
      var presets = [].concat(_toConsumableArray(saved_ones), _toConsumableArray(native_ones));
      presets.forEach(function (preset) {
        return assert(preset.is_real_preset, preset.preset_id);
      });
      var preset_font_names = presets.map(function (preset) {
        var font_name = preset.preset_font_name;
        assert(font_name, preset.preset_id);
        return font_name;
      });
      preset_font_names = make_unique(preset_font_names);
      return preset_font_names;
    }
  }, {
    key: "generate_unique_preset_id_copy",
    value: function generate_unique_preset_id_copy(preset) {
      var preset_ids = this._get_all_preset_ids();

      var preset_id = preset.preset_id;
      assert(preset_id);
      var s = NameIdConverter.white_space_seralized;
      assert(s);
      var base = preset_id.split("_").join(s).split(/-edit(-|$)/)[0] + s + "edit";

      for (var _i2 = 1; _i2 < 100; _i2++) {
        var candidate = base + (_i2 === 1 ? "" : s + _i2);

        if (!preset_ids.includes(candidate)) {
          return candidate;
        }
      }

      assert(false);
    }
  }, {
    key: "_get_all_preset_ids",
    value: function _get_all_preset_ids() {
      var presets = this._get_all_presets();

      var preset_ids = presets.map(function (preset) {
        return preset.preset_id;
      });
      return preset_ids;
    }
  }, {
    key: "_get_all_presets",
    value: function _get_all_presets() {
      var _this$presets_ordered2 = this.presets_ordered,
          special_ones = _this$presets_ordered2.special_ones,
          saved_ones = _this$presets_ordered2.saved_ones,
          native_ones = _this$presets_ordered2.native_ones;
      var presets = [].concat(_toConsumableArray(special_ones), _toConsumableArray(saved_ones), _toConsumableArray(native_ones));
      return presets;
    }
  }, {
    key: "random_candidates",
    get: function get() {
      var _this$presets_ordered3 = this.presets_ordered,
          saved_ones = _this$presets_ordered3.saved_ones,
          native_ones = _this$presets_ordered3.native_ones;

      if (saved_ones.length > 1) {
        return saved_ones;
      }

      return native_ones;
    }
  }, {
    key: "presets_ordered",
    get: function get() {
      var special_ones = [this.creator_preset];

      if (this.randomizer_preset) {
        special_ones.push(this.randomizer_preset);
      }

      var saved_ones = this._get_saved_presets();

      var native_ones = _classPrivateFieldLooseBase(this, _native_presets)[_native_presets];

      assert(special_ones && saved_ones && native_ones);
      return {
        special_ones: special_ones,
        saved_ones: saved_ones,
        native_ones: native_ones
      };
    }
  }]);

  return PresetList;
}();

var _preset_savior = _classPrivateFieldLooseKey("preset_savior");

var _native_presets = _classPrivateFieldLooseKey("native_presets");

var PresetSerializer = /*#__PURE__*/function () {
  function PresetSerializer() {
    _classCallCheck(this, PresetSerializer);
  }

  _createClass(PresetSerializer, null, [{
    key: "serialize_preset",
    value: function serialize_preset(preset) {
      assert(preset instanceof SavedPreset); // Validation

      var preset_id = preset.preset_id,
          preset_values = preset.preset_values;
      var subapp_id = preset.tab_settings.subapp_id;
      var preset_data = new PresetData({
        preset_id: preset_id,
        preset_values: preset_values,
        subapp_id: subapp_id
      });
      var preset_string = serialize(preset_data);
      return preset_string;
    }
  }, {
    key: "deserialize_preset",
    value: function deserialize_preset(preset_string) {
      assert(preset_string.constructor === String);
      var preset_data = deserialize(preset_string); // share URLs cannot be migrated thus we migrate here at runtime

      if (preset_data.preset_name && !preset_data.preset_id && preset_data.preset_options && !preset_data.preset_values) {
        preset_data.preset_id = preset_data.preset_name;
        delete preset_data.preset_name;
        preset_data.preset_values = preset_data.preset_options;
        delete preset_data.preset_options;
      }

      if (preset_data.app_name && !preset_data.subapp_id) {
        preset_data.subapp_id = preset_data.app_name;
        delete preset_data.app_name;
      }

      preset_data = new PresetData(preset_data);
      return preset_data;
    }
  }]);

  return PresetSerializer;
}();

var Preset = /*#__PURE__*/function () {
  function Preset(_ref18) {
    var preset_id = _ref18.preset_id,
        preset_values = _ref18.preset_values,
        tab_settings = _ref18.tab_settings;

    _classCallCheck(this, Preset);

    this.preset_id = void 0;
    this.preset_values = void 0;
    this.tab_settings = void 0;
    this.is_randomizer_preset = false;
    this.is_creator_preset = false;
    assert(preset_id);
    assert([Object, PresetValues].includes(preset_values.constructor));
    assert(tab_settings);
    this.preset_id = preset_id;
    this.preset_values = preset_values;
    this.tab_settings = tab_settings; // Abstract class

    if ((this instanceof Preset ? this.constructor : void 0) === Preset) {
      throw new TypeError("Cannot construct Preset instances directly.");
    }
  }

  _createClass(Preset, [{
    key: "get_preset_value",
    value: function get_preset_value(option) {
      var option_id = option.option_id;
      assert(option_id);
      var preset_values = this.preset_values;

      if (option_id in preset_values) {
        var val = preset_values[option_id];
        assert(val !== null);
        return val;
      }

      return null;
    }
  }, {
    key: "is_real_preset",
    get: function get() {
      return !this.is_randomizer_preset && !this.is_creator_preset;
    }
  }, {
    key: "preset_font_name",
    get: function get() {
      var preset_font_name = this.get_preset_value(this.tab_settings.font_option);
      assert(preset_font_name, {
        preset_font_name: preset_font_name
      });
      return preset_font_name;
    }
  }, {
    key: "preset_name",
    get: function get() {
      var prettified = NameIdConverter.from_id_to_name(this.preset_id);
      assert(prettified, {
        prettified: prettified
      });
      return prettified;
    }
  }]);

  return Preset;
}();

var SavedPreset = /*#__PURE__*/function (_Preset) {
  _inherits(SavedPreset, _Preset);

  function SavedPreset() {
    var _getPrototypeOf4;

    var _this18;

    _classCallCheck(this, SavedPreset);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this18 = _possibleConstructorReturn(this, (_getPrototypeOf4 = _getPrototypeOf(SavedPreset)).call.apply(_getPrototypeOf4, [this].concat(args)));
    Object.defineProperty(_assertThisInitialized(_this18), _generated_link, {
      writable: true,
      value: null
    });
    return _this18;
  }

  _createClass(SavedPreset, [{
    key: "is_saved_preset",
    get: function get() {
      return true;
    }
  }, {
    key: "share_link",
    get: function get() {
      if (!_classPrivateFieldLooseBase(this, _generated_link)[_generated_link]) {
        return _classPrivateFieldLooseBase(this, _generated_link)[_generated_link] = LinkSerializer.to_url(this);
      }

      return _classPrivateFieldLooseBase(this, _generated_link)[_generated_link];
    }
  }]);

  return SavedPreset;
}(Preset);

var _generated_link = _classPrivateFieldLooseKey("generated_link");

var NativePreset = /*#__PURE__*/function (_Preset2) {
  _inherits(NativePreset, _Preset2);

  function NativePreset(args) {
    var _this19;

    _classCallCheck(this, NativePreset);

    _this19 = _possibleConstructorReturn(this, _getPrototypeOf(NativePreset).call(this, args));
    var preset_id = args.preset_id;
    assert(!preset_id.includes("-"), {
      preset_id: preset_id
    });
    assert(/^[a-zA-Z0-9_]+$$/.test(preset_id), {
      preset_id: preset_id
    });
    return _this19;
  }

  return NativePreset;
}(Preset);

var PresetData = function PresetData(args) {
  _classCallCheck(this, PresetData);

  this.subapp_id = void 0;
  this.preset_id = void 0;
  this.preset_values = void 0;

  // I don't know why but even after all migrations applied a user
  // had a `preset_options` prop in its local storage.
  if (args.preset_options && !args.preset_values) {
    args.preset_values = args.preset_options;
    delete args.preset_options;
  }

  var preset_id = args.preset_id,
      preset_values = args.preset_values,
      subapp_id = args.subapp_id,
      rest = _objectWithoutProperties(args, ["preset_id", "preset_values", "subapp_id"]);

  assert(Object.keys(rest).length === 0 && preset_id && preset_values && subapp_id, "malformatted preset data", args);
  this.subapp_id = subapp_id;
  this.preset_id = preset_id;
  this.preset_values = new PresetValues(preset_values);
};

var PresetValues = function PresetValues(args) {
  _classCallCheck(this, PresetValues);

  assert([Object, PresetValues].includes(args.constructor), args, args.constructor);
  Object.assign(this, args);
};

var PresetSavior = /*#__PURE__*/function () {
  function PresetSavior(_ref19) {
    var subapp_id = _ref19.subapp_id;

    _classCallCheck(this, PresetSavior);

    Object.defineProperty(this, _subapp_id, {
      writable: true,
      value: null
    });
    assert(subapp_id);
    _classPrivateFieldLooseBase(this, _subapp_id)[_subapp_id] = subapp_id;
  }

  _createClass(PresetSavior, [{
    key: "get_saved_presets",
    value: function get_saved_presets() {
      return this._get_presets();
    }
  }, {
    key: "save_preset",
    value: function save_preset(preset) {
      var preset_id = preset.preset_id,
          preset_values = preset.preset_values;
      assert(preset_id);
      assert(preset_values);

      var presets = this._get_presets();

      if (presets.find(function (preset) {
        return preset.preset_id === preset_id;
      })) {
        // @ts-ignore
        assert.warning("Trying to save " + preset_id + " but it is already saved.");
        return;
      }

      var subapp_id = _classPrivateFieldLooseBase(this, _subapp_id)[_subapp_id];

      var preset_data = new PresetData({
        preset_id: preset_id,
        preset_values: preset_values,
        subapp_id: subapp_id
      });
      presets.push(preset_data);

      this._save_presets(presets);
    }
  }, {
    key: "remove_preset",
    value: function remove_preset(preset) {
      var preset_id = preset.preset_id;
      assert(preset_id);

      var presets = this._get_presets();

      var old_length = presets.length;
      presets = presets.filter(function (preset) {
        return preset.preset_id !== preset_id;
      });
      var new_length = presets.length;

      if (new_length === old_length) {
        // @ts-ignore
        assert.warning(false, "Preset " + preset_id + " not found.");
      }

      if (new_length !== old_length - 1) {
        // @ts-ignore
        assert.warning(false, "Preset " + preset_id + " found multiple times.");
      }

      this._save_presets(presets);
    }
  }, {
    key: "_get_presets",
    value: function _get_presets() {
      var presets = store.get_val(this._storage_key) || []; // Validation

      assert(presets.constructor === Array);
      presets = presets.map(function (preset_data) {
        return new PresetData(preset_data);
      });
      return presets;
    }
  }, {
    key: "_save_presets",
    value: function _save_presets(presets) {
      // Validation
      assert(presets.constructor === Array);
      presets.forEach(function (preset_data) {
        assert(preset_data instanceof PresetData);
      });
      store.set_val(this._storage_key, presets);
    }
  }, {
    key: "_storage_key",
    get: function get() {
      return _classPrivateFieldLooseBase(this, _subapp_id)[_subapp_id] + "_presets";
    }
  }]);

  return PresetSavior;
}();

var _subapp_id = _classPrivateFieldLooseKey("subapp_id");

var FakePreset = /*#__PURE__*/function () {
  function FakePreset() {
    _classCallCheck(this, FakePreset);

    this.is_randomizer_preset = void 0;
    this.is_creator_preset = void 0;
    this.preset_id = void 0;
    this.preset_name = void 0;
  }

  _createClass(FakePreset, [{
    key: "get_preset_value",
    value: function get_preset_value() {
      return null;
    }
  }]);

  return FakePreset;
}();

var RandomizerPreset = /*#__PURE__*/function (_FakePreset) {
  _inherits(RandomizerPreset, _FakePreset);

  function RandomizerPreset(_ref20) {
    var _this20;

    var preset_list = _ref20.preset_list;

    _classCallCheck(this, RandomizerPreset);

    _this20 = _possibleConstructorReturn(this, _getPrototypeOf(RandomizerPreset).call(this));
    Object.defineProperty(_assertThisInitialized(_this20), _picked, {
      writable: true,
      value: null
    });
    _this20.is_randomizer_preset = true;
    _this20.is_creator_preset = false;
    _this20.preset_id = "_random";
    _this20.preset_name = "<Random>";
    _this20.preset_list = void 0;
    _this20.is_randomizer_preset = true;
    _this20.preset_list = preset_list;
    return _this20;
  }

  _createClass(RandomizerPreset, [{
    key: "pick_random_preset",
    value: function pick_random_preset() {
      var random_candidates = this.preset_list.random_candidates;
      var idx = Math.floor(Math.random() * random_candidates.length);
      return random_candidates[idx];
    }
  }, {
    key: "random_preset",
    get: function get() {
      if (!_classPrivateFieldLooseBase(this, _picked)[_picked]) {
        _classPrivateFieldLooseBase(this, _picked)[_picked] = this.pick_random_preset();
      }

      assert(_classPrivateFieldLooseBase(this, _picked)[_picked].is_real_preset, _classPrivateFieldLooseBase(this, _picked)[_picked].preset_id, _classPrivateFieldLooseBase(this, _picked)[_picked]);
      return _classPrivateFieldLooseBase(this, _picked)[_picked];
    }
  }]);

  return RandomizerPreset;
}(FakePreset);

var _picked = _classPrivateFieldLooseKey("picked");

var CreatorPreset = /*#__PURE__*/function (_FakePreset2) {
  _inherits(CreatorPreset, _FakePreset2);

  function CreatorPreset() {
    var _getPrototypeOf5;

    var _this21;

    _classCallCheck(this, CreatorPreset);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this21 = _possibleConstructorReturn(this, (_getPrototypeOf5 = _getPrototypeOf(CreatorPreset)).call.apply(_getPrototypeOf5, [this].concat(args)));
    _this21.is_randomizer_preset = false;
    _this21.is_creator_preset = true;
    _this21.preset_id = "_creator";
    _this21.preset_name = "<Creator>";
    return _this21;
  }

  return CreatorPreset;
}(FakePreset);

var NameIdConverter = /*#__PURE__*/function () {
  function NameIdConverter() {
    _classCallCheck(this, NameIdConverter);
  }

  _createClass(NameIdConverter, null, [{
    key: "from_id_to_name",
    value: function from_id_to_name(id) {
      assert(id);
      var sep_regex = /[-_]/;
      assert("--a-_-_--".split(sep_regex).filter(Boolean).join("") === "a");
      var name = id.split(sep_regex).filter(Boolean).map(function (word) {
        return word[0].toUpperCase() + word.slice(1);
      }).join(" "); // console.log({id, name});

      return name;
    }
  }, {
    key: "from_name_to_id",
    value: function from_name_to_id(name) {
      assert(name);
      var sep_regex = /[\s-_]/;
      assert("  -- a-  _-  _--".split(sep_regex).filter(Boolean).join("") === "a");
      var id = name.split(sep_regex).filter(Boolean).join(NameIdConverter.white_space_seralized).toLowerCase(); // console.log({name, id});

      return id;
    }
  }]);

  return NameIdConverter;
}();

NameIdConverter.white_space_seralized = "-";

function make_unique(arr) {
  return Array.from(new Set(arr.filter(Boolean))).sort();
} // TODO-later
// What Preset values should be required before saving? What happens when the user sets some to ''?
// TypeScript
//  - Create a strict type for preset_id


var LinkSerializer = /*#__PURE__*/function () {
  function LinkSerializer() {
    _classCallCheck(this, LinkSerializer);
  }

  _createClass(LinkSerializer, null, [{
    key: "_to_base64",
    value: function _to_base64(str) {
      var str__base64 = window.btoa(str);
      assert(window.btoa("ab?") === "YWI/");
      str__base64 = str__base64.split("/").join("_");
      assert(window.btoa("ab>") === "YWI+");
      str__base64 = str__base64.split("+").join("-");
      return str__base64;
    }
  }, {
    key: "_from_base64",
    value: function _from_base64(str__base64) {
      str__base64 = str__base64.split("_").join("/");
      str__base64 = str__base64.split("-").join("+");
      var str = window.atob(str__base64);
      return str;
    }
  }, {
    key: "to_url",
    value: function to_url(preset) {
      assert(preset instanceof Preset);
      assert(preset.is_saved_preset);
      var preset_string = PresetSerializer.serialize_preset(preset);

      var preset_base64 = this._to_base64(preset_string);

      var url_base = window.location.href.split("#")[0];
      var preset_id = preset.preset_id;
      var name_encoded = encodeURIComponent(preset_id); // @ts-ignore

      assert.warning(name !== name_encoded, {
        name: name,
        name_encoded: name_encoded
      });
      var link = url_base + "#" + name_encoded + "/" + preset_base64;
      return link;
    }
  }, {
    key: "from_url",
    value: function from_url() {
      var preset_url = window.location.href;
      var pipe_data = preset_url.split("#")[1];

      if (!pipe_data) {
        return null;
      } // Old Clock Tab URL for fullscreen mode


      if (["/fullscreen", "fullscreen"].includes(pipe_data)) {
        return null;
      } // Not sure why some users have a Data URI appended to their URL


      if (pipe_data.startsWith("data:image")) {
        return null;
      }

      pipe_data = pipe_data.split("/").filter(Boolean)[1];

      if (!pipe_data) {
        return null;
      }

      try {
        pipe_data = this._from_base64(pipe_data);
      } catch (err) {
        on_error(err);
        return null;
      }

      var preset_data;

      try {
        preset_data = PresetSerializer.deserialize_preset(pipe_data);
      } catch (err) {
        on_error(err);
        return null;
      }

      return preset_data;

      function on_error(err) {
        show_toast("Wrong URL. The URL could not be processed.", {
          is_error: true
        });
        track_error({
          name: "preset_url_parsing",
          value: pipe_data,
          err: err
        });
        console.log(pipe_data);
        console.error(err);
      }
    }
  }]);

  return LinkSerializer;
}();